import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      //待选择考评员列表
      comList: [],
      form: {
        comName: ""
      },
      //添加考评员id
      ids: [],
      //考评员列表
      list: [],
      //删除考评员id
      comIds: [],
      //待选择列表
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      dialogVisible: false,
      //考评员列表
      pageTeaIndex: 1,
      pageTeaSize: 10,
      teaTotal: 0,
      commName: ""
    };
  },
  props: {
    siteId: {
      type: String,
      default: ""
    }
  },
  created: function created() {
    this.getSetUpCommentatorList();
  },
  methods: {
    /* 默认是否已选中 */
    checkboxInit: function checkboxInit(row, index) {
      return row.isAdd;
    },
    //返回上一级
    goBack: function goBack() {
      this.$router.push({
        name: "adoptSchool"
      });
    },
    //查询待选择列表
    search: function search() {
      this.getCommentatorList();
    },
    //查询列表
    searchCom: function searchCom() {
      this.getSetUpCommentatorList();
    },
    //获取考评员列表
    getSetUpCommentatorList: function getSetUpCommentatorList(page) {
      var that = this;
      this.$http.post("/api/XOrg/SetUpManager/getSetUpCommentatorList", {
        name: this.commName,
        page: page,
        PageSize: this.pageTeaSize
      }).then(function (rst) {
        if (rst.code > 0) {
          that.list = rst.list;
          that.teaTotal = rst.pagination.totalCount;
          that.pageTeaSize = rst.pagination.pageSize;
          that.pageTeaIndex = rst.pagination.pageIndex;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    //添加考评员
    addSetUpCommentator: function addSetUpCommentator() {
      var that = this;
      this.$http.post("/api/XOrg/SetUpManager/addSetUpCommentator", {
        siteId: this.siteId,
        commentatorIds: this.ids
      }).then(function (rst) {
        if (rst.code > 0) {
          that.$message.success(rst.msg);
          that.dialogVisible = false;
          that.getSetUpCommentatorList(1);
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    //待选择考评员列表
    getCommentatorList: function getCommentatorList(page) {
      var that = this;
      this.$http.post("/api/XOrg/SetUpManager/getCommentatorList", {
        name: this.form.comName,
        page: page,
        PageSize: this.pageSize
      }).then(function (rst) {
        if (rst.code > 0) {
          that.comList = rst.list;
          that.total = rst.pagination.totalCount;
          that.pageSize = rst.pagination.pageSize;
          that.pageIndex = rst.pagination.pageIndex;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    //批量删除考评员
    deletesCommentator: function deletesCommentator() {
      var _this = this;

      var that = this;
      this.$confirm("此操作将批量删除考评员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this.$http.post("/api/XOrg/SetUpManager/deleteSetUpCommentator", {
          ids: _this.comIds
        }).then(function (rst) {
          if (rst.code > 0) {
            that.getSetUpCommentatorList(1);
            that.$message.success(rst.msg);
          } else {
            that.$message.warning(rst.msg);
          }
        });
      }).catch(function () {
        _this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    //点击删除考评员
    deleteCommentator: function deleteCommentator(id) {
      var _this2 = this;

      var that = this;
      this.$confirm("此操作将删除该考评员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this2.$http.post("/api/XOrg/SetUpManager/deleteSetUpTeacher", {
          ids: id
        }).then(function (rst) {
          if (rst.code > 0) {
            that.getSetUpCommentatorList(1);
            that.$message.success(rst.msg);
          } else {
            that.$message.warning(rst.msg);
          }
        });
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this3 = this;

      this.ids = [];
      val.forEach(function (element) {
        _this3.ids.push(element.Id);
      });
    },
    handleTeaSelectionChange: function handleTeaSelectionChange(val) {
      var _this4 = this;

      this.comIds = [];
      val.forEach(function (element) {
        _this4.comIds.push(element.Id);
      });
    },
    handleClose: function handleClose() {
      //关闭对话框
      this.dialogVisible = false;
    },
    open: function open() {
      //弹出对话框
      this.dialogVisible = true;
      this.getCommentatorList();
    },
    onPageChangeHandler: function onPageChangeHandler(page) {
      this.getCommentatorList(page);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getCommentatorList(1);
    },
    onPageTeaChangeHandler: function onPageTeaChangeHandler(page) {
      this.getSetUpCommentatorList(page);
    },
    handleTeaSizeChange: function handleTeaSizeChange(val) {
      this.pageSize = val;
      this.getSetUpCommentatorList(1);
    }
  }
};